import { Link } from "react-router-dom";
import { useWorkspacesControllerGet } from "@/api/__generated__/orval/accounts";

type WorkspaceBreadcrumbProps = {
  accountId: string;
  workspaceId: string;
};

export const WorkspaceBreadcrumb = ({
  accountId,
  workspaceId,
}: WorkspaceBreadcrumbProps) => {
  const { data: workspaceData, isPending } = useWorkspacesControllerGet(
    accountId,
    workspaceId
  );

  if (isPending) {
    return <>...</>;
  }

  const workspace =
    workspaceData?.status === 200 ? workspaceData.data.data : undefined;

  return (
    <Link
      to={`/admin/account/${accountId}/organization/${workspace?.organizationId}/workspace/${workspaceId}`}
    >
      {workspace?.name ?? "..."}
    </Link>
  );
};
